import { Lightning } from '@lightningjs/sdk';
import { SelectOptionList } from '../../../components/option/SelectOptionList';
import { ScreenSize } from '../../../api/ScreenSize';
import { Theme } from '../../../config/theme';
import { Button } from '../../../components/shared/Button';
import { DetailTranslationKeys } from '../../../api/models/TranslationKeys';

/**
 * @callback rentSelected
 * @param {string} rent
 */

/**
 * @callback rentCancelled
 */

export class SelectRentPage extends Lightning.Component {
  static _template() {
    const halfW = ScreenSize.w * 0.5;
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Option.Background.Page,
      rect: true,
      Options: {
        x: halfW,
        y: 0,
        mountX: 0.5,
        type: SelectOptionList,
      },
      CouponButton: {
        type: Button,
        buttonMode: 'text',
        w: halfW,
        x: halfW,
        mountX: 0.5,
        h: 62,
        label: '',
        signals: {
          onActivate: 'couponSelected',
        },
      },
    };
  }

  _init() {
    const optionList = this.tag('Options');
    const couponButton = this.tag('CouponButton');
    optionList.data = {
      title: this._params.title,
      options: this._params.options,
      callback: this.optionSelected.bind(this),
    };
    couponButton.label = this._params.backend.translations.forKey(DetailTranslationKeys.detail_vouchercoupon);
    this.focusList = [optionList, couponButton];
    this.focusIndex = 0;
    couponButton.y = optionList.y + optionList.h + 15;
  }

  _handleUp() {
    this.focusIndex = Math.max(this.focusIndex - 1, 0);
  }

  _handleDown() {
    this.focusIndex = Math.min(this.focusIndex + 1, this._getFocusable().length - 1);
  }

  _getFocused() {
    return this._getFocusable()[this.focusIndex];
  }

  _handleBack() {
    this._cancelled && this._cancelled();
    this.fireAncestors('$closeDialog');
  }

  couponSelected() {
    this._onCoupon && this._onCoupon();
  }

  /**
   * @param {rentSelected} onSuccess
   */
  set onSuccess(onSuccess) {
    this._success = onSuccess;
  }

  set onCancelled(onCancelled) {
    this._cancelled = onCancelled;
  }

  set params(params) {
    this._params = params;
    this.onSuccess = params.onSuccess;
    this.onCancelled = params.onCancelled;
    this._onCoupon = params.onCoupon;
    this.tag('CouponButton').visible = params.showDiscount ? params.showDiscount : false;
  }

  optionSelected(obj) {
    this._success && this._success(obj);
  }

  _getFocusable() {
    return this.focusList.filter(elem => elem.visible);
  }
}
